export default "__VITE_ASSET__DgEm0vPo__"